import { ExperimentId, ExperimentsWithVariants } from './index';

export function selectVariant(experiment) {
  const { variants, weights, defaultVariant } = experiment || {};

  if (!variants || !Array.isArray(variants) || variants.length === 0) {
    return defaultVariant || null;
  }

  if (!weights || !Array.isArray(weights) || weights.length !== variants.length) {
    return defaultVariant || variants[0];
  }

  const totalWeight = weights.reduce((acc, w) => acc + (Number(w) || 0), 0);
  if (totalWeight <= 0) {
    return defaultVariant || variants[0];
  }

  let randomWeight = Math.random() * totalWeight;

  for (let i = 0; i < variants.length; i++) {
    randomWeight -= weights[i];
    if (randomWeight < 0) {
      return variants[i];
    }
  }

  return defaultVariant || variants[0];
}

export const initMissingAbExperiments = (currentlyActiveExperiments = {}) => {
  const activeExperiments = { ...currentlyActiveExperiments };
  const availableExperiments = Object.values(ExperimentId);
  const currentCountry = process.env.REACT_APP_COUNTRY_ID;

  for (const experimentId of availableExperiments) {
    const experimentConfig = ExperimentsWithVariants[experimentId];

    if (!experimentConfig) {
      continue;
    }

    const { allowedCountries, defaultVariant } = experimentConfig;

    // Sprawdzamy czy dany kraj jest dozwolony
    const isCountryAllowed = 
      !allowedCountries || 
      (Array.isArray(allowedCountries) && allowedCountries.includes(currentCountry));

    // Jeśli kraj NIE jest dozwolony -> wymuszamy wariant domyślny (ORIGINAL)
    if (!isCountryAllowed) {
      activeExperiments[experimentId] = defaultVariant || null;
      continue;
    }

    // Jeśli kraj JEST dozwolony i brak wariantu -> losujemy
    if (!activeExperiments[experimentId]) {
      activeExperiments[experimentId] = selectVariant(experimentConfig);
    }
  }

  return activeExperiments;
};